import { intlGet } from 'utils/intlGet';
import { isVeevaMedcomms } from './Environment';
import { ProjectMetadataMapMedcomms } from './MedComms/ProjectMetadata';

export enum ProjectMetadataTypePromomats {
  JOB_ID = 'DocNumb',
}

export interface ProjectMetadata {
  key: string;
  title: string;
  description: string;
}

const ProjectMetadataMapPromomats: Record<ProjectMetadataTypePromomats, ProjectMetadata> = {
  [ProjectMetadataTypePromomats.JOB_ID]: {
    key: 'number',
    title: intlGet('EditorToolbar.Token.Property.JobId', 'Title'),
    description: intlGet('EditorToolbar.Token.Property.JobId', 'Description'),
  },
};

export const ProjectMetadataMap = isVeevaMedcomms() ? ProjectMetadataMapMedcomms : ProjectMetadataMapPromomats;
